import request from '@/utils/request';
//网站配置数据
export function getIndex() {
    return request({
        url: 'index/linkList',
        method: 'get',
        
    });
}
// 友情链接
export function getLinkList() {
    return request({
        url: 'index/linkList',
        method: 'get',
        
    });
}
//图片配置
export function getIndexAd(params) {
    return request({
        url: 'index/image',
        method: 'get',
        params: params
    });
}
// 文字配置
export function getIndexText(params) {
    return request({
        url: 'index/text',
        method: 'get',
		params: params
    });
}
// 推荐城市列表
export function getCityList(params) {
    return request({
        url: 'New_list/cityList',
        method: 'get',
        params: params
    });
}
// 周刊列表
export function getWeeklyList(params) {
    return request({
        url: 'New_list/weeklyList',
        method: 'get',
        params: params
    });
}
// 新闻分类
export function getNewsType() {
    return request({
        url: 'New_list/newsType',
        method: 'get'
    });
}
// 新闻列表
export function getNewsList(params) {
    return request({
        url: 'New_list/newsList',
        method: 'get',
        params: params
    });
}
// 新闻详情
export function getNewsInfo(params) {
    return request({
        url: 'New_info/newsInfo',
        method: 'get',
        params: params
    });
}
// 首页新闻
export function getIndexNewsList() {
    return request({
        url: 'index/newsList',
        method: 'get'
    });
}
// 查询人员
export function getQueryStaff(params) {
    return request({
        url: 'index/query_staff',
        method: 'post',
        params: params
    });
}
// 底部外链
export function getBottomImage(params) {
    return request({
        url: 'index/bottom_image',
        method: 'post',
        params: params
    });
}
// 读报链接
export function getConfig(params) {
    return request({
        url: 'index/config_api',
        method: 'post',
        params: params
    });
}
// 首页顶部新闻
export function getTopNews(params) {
    return request({
        url: 'index/top_news',
        method: 'post',
        params: params
    });
}

export function getDownJumpList() {
    return request({
        url: 'index/downJumpList',
        method: 'get'
    });
}